<template>
  <div class="wd-rounded-2xl wd-p-px gradient-card">
    <div class="wd-rounded-2xl wd-bg-white wd-px-4 wd-pt-4 wd-overflow-hidden">
      <ai-summary-header :subtitle="$t('ai_summary_google')" :tooltip-text="$t('ai_google_notice')" />

      <div
        class="wd-relative wd-mt-1 wd--mx-4 wd-px-4 wd-pb-4"
        :class="[
          { 'wd-cursor-pointer': isMobile && isOverflowing },
          { 'wd-max-h-[152px] wd-overflow-hidden': isMobile && isOverflowing && !isExpanded },
        ]"
        @click="handleCardClick"
      >
        <div ref="cardContent">
          <google-ai-summary-content :google-highlight="googleHighlight" :product-usp="productUsp" :vibe-service="vibeService" />
        </div>

        <div
          v-if="isMobile && isOverflowing && !isExpanded"
          class="wd-absolute wd-bottom-0 wd-left-0 wd-right-0 wd-h-11 wd-flex wd-items-end wd-justify-center ai-summary-mask"
        >
          <funnow-svg-icon image-path="chevron-down_orange.svg" max-width="32" height="32" class="wd-p-1.5" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useElementSize } from '@vueuse/core'

import { useBreakpoints } from '@/composition/useBreakpoints'
import AiSummaryHeader from '@/components/ai-summary/ai-summary-header.vue'
import GoogleAiSummaryContent from '@/components/ai-summary/google-ai-summary-content.vue'
import FunnowSvgIcon from '@/components/icons/funnow-svg-icon.vue'

import type { BranchReviewSummaryItem, BranchReviewHighlightItem } from '@/types/api'

import { ReviewSummaryType } from '@/constants/reviewSummary'

const MOBILE_MAX_HEIGHT = 152

interface Props {
  summaries: BranchReviewSummaryItem[]
  highlights: BranchReviewHighlightItem[]
}

const props = defineProps<Props>()

const { isMobile } = useBreakpoints()

const cardContentRef = useTemplateRef('cardContent')
const { height: contentHeight } = useElementSize(cardContentRef)
const isExpanded = ref(false)

const productUsp = computed(() => props.summaries.find(s => s.type === ReviewSummaryType.PRODUCT_USP))
const vibeService = computed(() => props.summaries.find(s => s.type === ReviewSummaryType.VIBE_SERVICE))
const googleHighlight = computed(() => props.highlights[0])

const isOverflowing = computed(() => contentHeight.value > MOBILE_MAX_HEIGHT)

function handleCardClick() {
  if (!isMobile.value || !isOverflowing.value) return
  isExpanded.value = !isExpanded.value
}
</script>

<style scoped>
.gradient-card {
  background: linear-gradient(89.19deg, #ffad9e 0.7%, #ffc038 35.21%, rgba(255, 85, 55, 0.8) 99.3%);
  box-shadow: 0px 1px 4px 2px rgba(243, 39, 53, 0.2);
}

.ai-summary-mask {
  background: linear-gradient(0deg, #ffffff 21.82%, rgba(255, 255, 255, 0.31) 116.35%);
}
</style>
